import * as React from "react";
import { useHistory } from "react-router-dom";

import { titles } from "../../../constants/titles";
import {
  exchangeSchoolYearPath,
  nextYearClassesPath,
  clearErrorMessage,
  clearSuccessMessage,
  Context,
  bulkUpsertClasses,
  BULK_UPSERT_CLASSES_SUCCESS_MESSAGE,
  fetchNextClasses,
  FETCH_NEXT_CLASSES_SUCCESS_MESSAGE,
} from "../../../managerStore";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import ClassSpreadSheet from "../../../templates/manager/ClassSpreadSheet";
import { IClassForRegister } from "../../../state";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";

const BulkEditNextYearClasses = () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const { nextYear } = useCurrentYear();
  const [fetched, setFetched] = React.useState({
    classes: false,
  });
  const history = useHistory();

  React.useEffect(() => {
    if (state.success_message === BULK_UPSERT_CLASSES_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(nextYearClassesPath);
    }
    if (state.success_message === FETCH_NEXT_CLASSES_SUCCESS_MESSAGE) {
      setTimeout(() => {
        setFetched(s => ({ ...s, classes: true }));
      }, 200);
    }
  }, [history, dispatch, state.success_message]);

  const bulkUpsertClassesFunc = React.useCallback(
    (classes: IClassForRegister[]) => {
      dispatch(peep(bulkUpsertClasses(nextYear, classes)));
    },
    [dispatch, peep, nextYear],
  );

  React.useEffect(() => {
    dispatch(fetchNextClasses(nextYear));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, nextYear]);

  return (
    <div>
      <Breadcrumb
        links={[
          { title: titles.exchangeSchoolYear, to: exchangeSchoolYearPath },
          {
            title: `${titles.nextYearClasses} (${nextYear}年度)`,
            to: nextYearClassesPath,
          },
        ]}
        currentTitle={`${titles.bulkEditNextYearClasses} (${nextYear}年度)`}
      />
      {fetched.classes && (
        <ClassSpreadSheet
          title={`${titles.bulkEditNextYearClasses} (${nextYear}年度)`}
          calling={calling}
          error={state.error}
          year={nextYear}
          classes={state.next_classes}
          save={bulkUpsertClassesFunc}
        />
      )}
    </div>
  );
};

export default BulkEditNextYearClasses;
